import type { DrillLevel } from './drill-down.js';

/**
 * A group key as the address carries it: `null:` for the Unassigned group, or `name:` and a name the
 * service would accept. The router reads every value as JSON first, so the prefix keeps a name such
 * as `123` or `true` text.
 */
const GROUP_KEY_PATTERN = /^(null:|name:[\s\S]{1,120})$/;

/** The value as a group key, or undefined when it has another shape. */
function groupKeyParam(value: unknown): string | undefined {
  return typeof value === 'string' && GROUP_KEY_PATTERN.test(value)
    ? value
    : undefined;
}

/**
 * Reads the query of the Code Quality overview in Dashboards: the drill-down level, as group keys,
 * with an account only together with its portfolio. Anything else is dropped.
 */
export function parseDashboardSearch(raw: Record<string, unknown>): DrillLevel {
  const portfolio = groupKeyParam(raw.portfolio);
  if (portfolio === undefined) return {};
  const account = groupKeyParam(raw.account);
  return account === undefined ? { portfolio } : { portfolio, account };
}
